import React, { useEffect, useState } from 'react';
import { useInjection } from 'services/ioc/ioc.react';
import SnackbarStore from 'stores/SnackbarStore';
import { ServiceTypes } from 'constants/ServiceTypes';
import { NotificationType, SnackbarPosition } from 'interfaces/template/INotification';
import { acceptgreen, darkgrey, warningred } from 'styles/Colors';
import { observer } from 'mobx-react-lite';
import spinner from './images/spinner.png';
import { Description, SnackbarWrapper, StyledSpinner } from './styles/SnackbarStyles';
import { ReactComponent as SuccessIcon } from './images/success.svg';
import { ReactComponent as ErrorIcon } from './images/error.svg';

const Snackbar = observer(() => {
  const snackbarStore = useInjection<SnackbarStore>(ServiceTypes.SnackbarStore);
  const { styles } = useSnackbarPosition(snackbarStore.notification?.position);

  const getIcon = () => {
    if (snackbarStore.notification) {
      switch (snackbarStore.notification.type) {
        case NotificationType.error:
          return <ErrorIcon />;
        case NotificationType.loading:
          return <StyledSpinner src={spinner} alt='' />;
        case NotificationType.success:
          return <SuccessIcon />;
      }
    }
  };

  const getColor = () => {
    if (snackbarStore.notification) {
      switch (snackbarStore.notification.type) {
        case NotificationType.error:
          return warningred;
        case NotificationType.loading:
          return darkgrey;
        case NotificationType.success:
          return acceptgreen;
      }
    }
  };

  const dismissHandler = () => {
    snackbarStore.clearNotification();
  };

  return snackbarStore.notification ? (
    <SnackbarWrapper color={getColor()} styles={styles} onClick={dismissHandler}>
      {getIcon()}
      <Description>{snackbarStore.notification.message}</Description>
    </SnackbarWrapper>
  ) : null;
});

export default Snackbar;

const useSnackbarPosition = (position?: SnackbarPosition) => {
  const [styles, setStyles] = useState({
    top: 'unset',
    bottom: 'unset',
    left: 'unset',
    right: 'unset',
    transform: 'unset',
  });

  useEffect(() => {
    switch (position) {
      case SnackbarPosition.Top:
        setStyles({
          top: '20px',
          bottom: 'unset',
          left: '50%',
          right: 'unset',
          transform: 'translateX(-50%)',
        });
        return;
      case SnackbarPosition.Bottom:
        setStyles({
          top: 'unset',
          bottom: '20px',
          left: '50%',
          right: 'unset',
          transform: 'translateX(-50%)',
        });
        return;
      case SnackbarPosition.RightBottom:
        setStyles({
          top: 'unset',
          bottom: '20px',
          left: '50%',
          right: '20px',
          transform: 'unset',
        });
        return;
      case SnackbarPosition.LeftTop:
        setStyles({
          top: '20px',
          bottom: 'unset',
          left: '20px',
          right: 'unset',
          transform: 'unset',
        });
        return;
      case SnackbarPosition.RightTop:
        setStyles({
          top: '20px',
          bottom: 'unset',
          left: 'unset',
          right: '20px',
          transform: 'unset',
        });
        return;
      case SnackbarPosition.LeftBottom:
      default:
        setStyles({
          top: 'unset',
          bottom: '20px',
          left: '20px',
          right: 'unset',
          transform: 'unset',
        });
    }
  }, [position]);

  return { styles };
};
